/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import { PlusIcon } from "./icon/TablerIcon";
import ListForItem from "./ListForItem";
import Modal from "../modal/Modal";
import AddEditModal from "./AddEditModal";
import { Categories } from "./models";
import { useAppDispatch, useAppSelector } from "src/store";
import {
  showCategoriesForAdd,
} from "src/store/kategorija-store";

interface Props {
  title: string;
  titleButton: string;
  titleCg: string;
  editFunction: (data: any) => any;
  deleteFunction: (id: Number) => any;
  data: any;
  addFunction: (data: any) => any;
  categories?: Categories;
}

function TableForItems({
  title,
  titleButton,
  titleCg,
  editFunction,
  deleteFunction,
  data,
  addFunction,
  categories,
}: Props) {
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const dispatch = useAppDispatch();

  const { addCategories: categoriesFromApi } = useAppSelector(
    (state) => state.category
  );

  useEffect(() => {
    if (categories) {
      dispatch(showCategoriesForAdd({ per_page: 100 }));
    }
  }, []);
  return (
    <div className="kategorije">
      <div className="title-first row g-2 align-items-center">
        <div className="col">
          <h2 className="page-title">{title}</h2>
        </div>
        <div className="col-auto ms-auto d-print-none">
          <div className="btn-list">
            <a
              onClick={handleShow}
              className="btn btn-primary"
            >
              <PlusIcon />
              {titleButton}
            </a>
          </div>
        </div>
      </div>

      {data && (
        <div className="card">
        
          <div className="card-table table-responsive">
            <div className="tab-content">
              <div className="tab-pane active">
                <table className="table table-vcenter">
                  <thead>
                    <tr>
                      <th>{titleCg}</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <ListForItem
                      categories={categories ? categoriesFromApi : null}
                      editFunction={editFunction}
                      deleteFunction={deleteFunction}
                      lista={data.data}
                    />
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      {showModal && (
        <Modal onClose={handleClose}>
          <AddEditModal
            categories={categories ? categoriesFromApi : null}
            titleCG={titleCg}
            addFunction={addFunction}
            onClose={handleClose}
          />
        </Modal>
      )}
    </div>
  );
}

export default TableForItems;
